/* eslint-disable no-param-reassign */
import loadConfiguration from 'ggApp/utils/configuration';
import load from 'loadjs';

const NETHONE_SDK_ID = 'nethoneSdk';
export function loadNethone() {
    if (!document || !window) {
        return Promise.reject(new Error('document or window are not defined'));
    }
    const addAttribute = (_, scriptElement) => {
        scriptElement.dataset.main = 'nethone-js';
        scriptElement.crossOrigin = 'user-credentials';
    };

    return new Promise((resolve, reject) => {
        const { NETHONE_CLIENT_URL } = loadConfiguration();
        if (load.isDefined(NETHONE_SDK_ID) || !NETHONE_CLIENT_URL) {
            resolve();
            return;
        }
        load(NETHONE_CLIENT_URL, NETHONE_CLIENT_URL, {
            success: resolve,
            before: addAttribute,
            error: reject,
        });

        load.ready(NETHONE_SDK_ID, window.dftp);
    });
}

export function initNethone(options = {}) {
    if (!window || !window.dftp) {
        return;
    }

    const { attemptReference, sensitiveFields, secretFields } = options;

    window.dftp.init({
        attemptReference,
        sensitiveFields,
        secretFields,
    });
}

export function profileNethone() {
    if (!window || !window.dftp) {
        return;
    }

    window.dftp.profile();
}
